import React, { useState, useEffect, useCallback } from 'react';
import { FileCopyOutlined } from '@material-ui/icons';
import { Card } from '@material-ui/core';
/********** COMPONENTS **********/
import TitleWithIconBar from 'component/TitleWithIcon';
import LoadingSpinner from 'component/LoadingSpinner';
import AlertElement from 'component/AlertElement';
import Form from "component/Form/FormTwoColumns";
/********** SERVICES **********/
import ApiServices from 'service/ApiServices';
import { functions } from 'constant';
/********** STYLES **********/
import { useStyles } from './style';

const ReporteAfiliados = () => {
/********** VARIABLES **********/
    const classes = useStyles();
    const [elementAlertModal, setElementAlertModal] = useState({openAlert: false, titleAlert: '', typeAlert: '' }),
    [loadingSpinner, setLoadingSpinner] = useState({openLoading: false, message: ''}),
    [elements] = useState({
        /* Inputs para Reporte Afiliaciones */
        idDepartamento: {
            idelement: "idDepartamento", value: null , label: "Seleccione el departamento *",  validators: 'required',
            errorMessages:['Seleccione el departamento'], isError:false, elementType:'autocompleteV2', list: [], handler: handlerDepartament,
            showSelectAutoComplete: true, disabled: false
        },
        idMunicipio: { 
            idelement: "idMunicipio", value: null , label: "Seleccione el municipio *",  validators: 'required',
            errorMessages:['Seleccione el municipio'], isError:false, elementType:'autocompleteV2', list: [], showSelectAutoComplete: true, disabled: false
        },
    }),
    [buttonList] = useState({
        "register": {"label": "Generar reporte", "callback": generateReport, "loading": false, "size": "medium", "color": "#fff", "icon": <FileCopyOutlined/>, "background": "", "showButton": true}
    });
/********** FUNCTIONS **********/

/********** FUNCTIONS **********/
    useEffect(() => {
        getDepartamentData();
    },[])

    /* Función para obtener el listado de las organizaciones políticas para mostrarlas en el select */
    const getDepartamentData = useCallback(async () => {
        try {
            setLoadingSpinner({...loadingSpinner, openLoading: true, message: 'Obteniendo datos de los Departamentos...'});
            let response = await ApiServices.departamentos.listRegisterPublic();
            if(response.error !== null){
                setElementAlertModal({...elementAlertModal, openAlert: true, titleAlert: response.error.message, 
                    typeAlert: 'error' });
            } else {
                let dataDepartament = response.data.filter((_, index) => ![22, 23, 24].includes(index));
                let newDataDepartament = [{id: 0, name: 'TODOS LOS DEPARTAMENTOS'}, ...dataDepartament];
                elements.idDepartamento.list = newDataDepartament;
            }
            setLoadingSpinner({...loadingSpinner, openLoading: false});
        } catch (exception) {
            setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'error', 
                titleAlert: 'Error al obtener los datos de Departamentos' + exception + ', consulte con soporte.'});
            setLoadingSpinner({...loadingSpinner, openLoading: false});
        }
    },[]);

    /* ESTE CODIGO DEBE OPTIMIZARSE PARA UTILIZAR REDUX Y EVITAR OBTENER MUNICIPIOS CADA VEZ */
    /* Función que se ejecuta cuando se detecta un cambio en el Autocomplete de Departamentos */
    async function handlerDepartament({target}){
        if(target.value === ''){
            elements.idMunicipio.list = [];
            elements.idMunicipio.value = null;
        } else {
            //const municipioStore = municipiosRef.current;
            elements.idMunicipio.list = [];
            elements.idMunicipio.value = null;
            getMunicipalitiesData(target?.value);
            /* if (municipioStore && municipioStore.length > 0) {
                const currentMunicipality = municipioStore?.filter((value) => 
                    Number(value.departamentoId) === Number(target?.value));            
                if(currentMunicipality?.length > 0) {
                    let newMunicipalities = [{id: 0, name: 'TODOS LOS MUNICIPIOS'}, ...currentMunicipality];
                    elements.idMunicipio.list = newMunicipalities;
                } else {
                    getMunicipalitiesData(target?.value);
                }
            } else {
                getMunicipalitiesData(target?.value);
            } */
        }
    }

    /* Función para obtener los municipios según el departamento que hayamos seleccionado */
    const getMunicipalitiesData = async (idDepartament) => {
        try {
            setLoadingSpinner({...loadingSpinner, openLoading: true, message: 'Obteniendo datos de los Municipios...'});
            if(idDepartament === 0){
                let newMunicipalities = [{id: 0, name: 'TODOS LOS MUNICIPIOS'}];
                elements.idMunicipio.list = newMunicipalities;
            } else {
                ApiServices.municipios.searchCriteria.clear();
                ApiServices.municipios.searchCriteria.setOperator("and");
                ApiServices.municipios.searchCriteria.addEquals("id.departamentoId", idDepartament);
                ApiServices.municipios.setIsPublic(true);
                let response = await ApiServices.municipios.listRegisterCriteria();
                if(response.error !== null){
                    setElementAlertModal({...elementAlertModal, openAlert: true, titleAlert: response.error.message, 
                        typeAlert: 'error' });
                } else {
                    var datos = response.data;
                    let municipalitiesArray = [];
                    Object.keys(datos).forEach((element, key, _array) => {
                        municipalitiesArray.push({
                            id: datos[element].id.id,
                            name: datos[element].name,
                          });
                    });
                    let newMunicipalities = [{id: 0, name: 'TODOS LOS MUNICIPIOS'}, ...municipalitiesArray];
                    elements.idMunicipio.list = newMunicipalities;
                }
            }
            setLoadingSpinner({...loadingSpinner, openLoading: false});
        } catch (exception) {
            setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'error', 
                titleAlert: 'Error al obtener los datos de Municipios' + exception + ', consulte con soporte.'});
            setLoadingSpinner({...loadingSpinner, openLoading: false});
        }
    }

    /* Función para obtener reportes según los parametros seleccionados */
    async function generateReport(){
        try {
            if(elements.idDepartamento.value.id === null){
                setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'warning', 
                    titleAlert: 'Seleccione primero todos los campos.'});
            } else {
                setLoadingSpinner({ ...loadingSpinner, openLoading: true, message: 'Generando reporte...' }); 
                let data = {codigoDepto: elements.idDepartamento.value.id, codigoMun: elements.idMunicipio.value.id}


                let response = await ApiServices.informacionGeneralMiOrganizacion.ListarAfiliado(data);
                if(response.error !== null){
                    var messageError = JSON.parse(response.error.message);
                    setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'error', titleAlert: messageError.message});
                } else {
                    functions.downloadPDFFromStringBase64(response.data.base64, "Listado de Afiliados");
                }  
                setLoadingSpinner({ ...loadingSpinner, openLoading: false});  
            }
        } catch (exception) {
            setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'error', 
                titleAlert: 'Error al generar el reporte' + exception + ', consulte con soporte.'});
            setLoadingSpinner({ ...loadingSpinner, openLoading: false});
        }
    }

    /*  El método cierra el "AlertElement" que muestra los modales de alertas, se ejecuta desde el "AlertElement" */
    const handCloseModal = () => {
        setElementAlertModal({...elementAlertModal, openAlert: false})
    }
    
/********** RENDER **********/
    return (
        <div className={classes.root}>
            {loadingSpinner.openLoading && <LoadingSpinner open={loadingSpinner.openLoading} message={loadingSpinner.message}/>}
            {elementAlertModal.openAlert && <AlertElement typeAlert={elementAlertModal.typeAlert} openModal={elementAlertModal.openAlert} 
                title={elementAlertModal.titleAlert} handCloseModal={handCloseModal} />}
            <TitleWithIconBar title="Reporte de Afiliados" icon={"/menu/Constancia.png"} />
            <div className={classes.cardMainContainer}>
                <Card className={classes.cardContainer}>
                    <div className={classes.searchContainer}>
                        <Form elements={elements} buttonList={buttonList} />
                    </div>
                </Card>
            </div>
        </div>
    )
}

export default ReporteAfiliados;